import React, { useContext, useMemo } from 'react';
import Context from './ActionPlanContext';
import operActionPlanService from '../../../../services/operActionPlanService';
import { IdRoute } from '../../../../types';
import useServiceReducer from '../../../../shared/hooks/useServiceReducer';
import actionPlanReducer from './ActionPlanReducer';
import MainContext from '../../../App/MainProvider/context';

const ActionPlanProvider: React.FC<IdRoute> = ({ id: operationId, children }) => {
  const { inSuperUserMode, inGuidanceServiceMode } = useContext(MainContext);
  const [actionPlanContext, loading, , , , reload] = useServiceReducer(
    operActionPlanService.getActionPlanContext,
    actionPlanReducer,
    operationId,
    [inSuperUserMode(), inGuidanceServiceMode()]
  );

  const value = useMemo(
    () =>
      actionPlanContext && {
        operationActionPlans: actionPlanContext.operationActionPlans,
        supervisionReportLanguage: actionPlanContext.supervisionReportLanguage,
        canCreate: actionPlanContext.canCreate,
        aplicablePolicyOptions: actionPlanContext.aplicablePolicyOptions,
        indicators: actionPlanContext.indicators,
        grantedWrite: actionPlanContext.grantedWrite,
        blokedBySR: actionPlanContext.blokedBySR,
        stepSR: actionPlanContext.stepSR,
        loading,
        reload,
      },
    [actionPlanContext, loading, reload]
  );

  return value && <Context.Provider value={value}>{children}</Context.Provider>;
};

export default ActionPlanProvider;
